import React from 'react';

// \nを改行に変更する
const formatMessage = message => {
  if (message) {
    const formattedMessage = message
      .split('\\n')
      .reduce((prev, curr) => [prev, <br key />, curr]);
    return formattedMessage;
  }
};

/**
 * 成功・失敗のダイアログ
 *
 * @param {*} { success:成功時のクリックの処理, updateSuccess:trueなら成功表示/falseなら失敗表示, error:失敗時のクリックの処理, msg:ダイアログのメッセージ }
 */
export const DialogSuccessError = ({
  success,
  updateSuccess,
  error,
  msg,
  msgDetail,
  multilineText,
  labelBtnError = '戻る',
}) => (
  <div id='modal-dialog-confirm-selected' className={'modal show'}>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>{formatMessage(msg)}</span>
      </div>
      {msgDetail ? (
        <div
          className={
            multilineText
              ? 'dialog-md__body dialog-md__body-prewrap text-left'
              : 'dialog-md__body text-center'
          }
        >
          {formatMessage(msgDetail)}
        </div>
      ) : null}
      <div className='dialog-md__footer'>
        {updateSuccess ? (
          <button
            id='modal-close-confirm-selected'
            className='btn-fixedsize--sub'
            onClick={success}
          >
            閉じる
          </button>
        ) : (
          <button
            id='modal-close-confirm-selected'
            className='btn-fixedsize--sub'
            onClick={error}
          >
            {labelBtnError}
          </button>
        )}
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/DialogSuccessError.jsx